import { useParams } from "react-router-dom";

import { useUserEventCount } from "src/features/shared/UserActivityTracking/TrackActivityCount";
import { useUpdateOptionSectionDetailsMutation, useUpdateSectionDetailsMutation } from "../../queries";

const useUpdateSectionName = () => {
    const { bomId = '0' } = useParams();
    const { pushUserEventCount } = useUserEventCount();

    const { mutateAsync: updateSectionData } = useUpdateSectionDetailsMutation();
    const { mutateAsync: updateOptionSectionData } = useUpdateOptionSectionDetailsMutation();

    const onEditSectionName = async (sectionId: number, updatedName: string, isOptionSection: boolean) => {

        if (isOptionSection) {
            await updateOptionSectionData({ bomId: Number(bomId), sectionId: sectionId, input: { name: updatedName } });
        } else {
            await updateSectionData({
                bomId: Number(bomId),
                sectionId: sectionId,
                input: { name: updatedName }
            });
        }
        pushUserEventCount({ eventType: 'section_renamed', needCummulation: true });
    };
    return { onEditSectionName }
};

export default useUpdateSectionName;
